const headers = [
    { text: "Código", value: "id" },
    { text: "Nome", value: "name" },
    { text: "E-mail", value: "email" },
    { text: "Ações", value: "actions" }
]

export { headers };